<template>
  <div class="description">
    <div class="container">
      <div
        v-for="(item, key, index) in filteredData"
        :key="index"
        class="block"
      >
        <p class="title">{{ $t(key) }}</p>
        <div class="catigory">
          <p
            v-if="pickupBoxes?.[item]"
            :class="{
              pickupBoxes: true,
              'pickupBoxes-bestCategory': key === 'bestCategory'
            }"
          >
            {{ $t('pickupDeliveries') }}
          </p>
          <p
            :class="{
              item: true,
              bestCategory: key === 'bestCategory'
            }"
          >
            {{
              key === 'mostDissatisfiedCustomersHours'
                ? isValidHours(item)
                : getCategory(item)
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Description',
  props: ['data', 'pickupBoxes', 'options'],
  computed: {
    filteredData() {
      if (!this.data) return {};

      const rest = {
        ...this.data
      };
      delete rest.mostCustomersHours;

      return rest;
    }
  },
  methods: {
    formatHourRange(range: string): string {
      const [start, end] = range.split('-');

      return `${start}:00 - ${end}:00`;
    },
    isValidHours(value: string) {
      if (
        value === 'NaN' ||
        value === '-NaN' ||
        value === null ||
        value === undefined
      ) {
        return '-';
      }

      return value && value.length
        ? `${this.$t('clock')} ${this.formatHourRange(value)}`
        : '-';
    },
    getCategory(category: string) {
      if (!category) return '-';

      const lang = localStorage.getItem('locale');

      // A category can be a pickup box rather than a feedback option — name it
      // as such so the box number is not mistaken for a category.
      if (this.pickupBoxes && this.pickupBoxes[category]) {
        return `${this.$t('pickupBox')} ${this.pickupBoxes[category]}`;
      }

      if (this.options && this.options[category]) {
        const translations = this.options[category].translations || {};

        const translation =
          translations[lang as keyof typeof translations] ||
          translations.en ||
          category;

        return (
          translation.charAt(0).toUpperCase() +
          translation.slice(1).replace(/_/g, ' ')
        );
      }

      return (
        category.charAt(0).toUpperCase() + category.slice(1).replace(/_/g, ' ')
      );
    }
  }
})
export default class Description extends Vue {}
</script>

<style lang="scss" scoped>
.description {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  @media (max-width: 1366px) {
    padding: 24px;
  }
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    width: 100%;
    max-width: 1182px;
    .block {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 217px;
      width: 360px;
      border: 1px solid $border;
      border-radius: 4px;
      @media (max-width: 1366px) {
        width: 336px;
      }
      @media (max-width: 1280px) {
        width: 302px;
      }
      .title {
        width: 93%;
        padding: 12px;
        font-size: 15px;
        line-height: 14px;
        color: $lineColor;
        border-bottom: 1px solid $border;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        @media (max-width: 1280px) {
          width: 92%;
        }
      }
      .catigory {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: center;
        .pickupBoxes {
          font-size: $eighteenSize;
          color: $negative;
          padding-bottom: 12px;
          &.pickupBoxes-bestCategory {
            color: $positive;
          }
        }
        .item {
          font-size: $twentyFourSize;
          color: $negative;
          &.bestCategory {
            color: $positive;
          }
        }
      }
    }
  }
}
</style>
